module.exports = __webpack_public_path__ + "static/media/map_cavity.d6ab113a.png";


//////////////////
// WEBPACK FOOTER
// ./public/pictures/markers/map_cavity.png
// module id = 2224
// module chunks = 0